import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import TreatmentCard from "./components/TreatmentCard";
import TreatmentInquiryForm from "./components/TreatmentInquiryForm";
import NewsletterSignup from "./components/NewsletterSignup";
import { treatmentCategories } from "./data";

export default function TreatmentsPage() {
  const [active, setActive] = useState<string>("all");

  const visible = active === "all" ? treatmentCategories : treatmentCategories.filter((c) => c.id === active);

  return (
    <div className="min-h-screen bg-white text-brand-900">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 md:pt-40 pb-14 md:pb-20 bg-brand-50/60 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="inline-block px-6 py-2 rounded-md bg-brand-600 text-white text-lg tracking-wider">療程資訊</div>
          <h1 className="mt-6 font-serif text-3xl md:text-5xl text-brand-800">專業療程一覽</h1>
          <p className="mt-4 text-brand-700/70 max-w-2xl text-sm md:text-base">
            以離子紅光細胞再生技術為核心，針對不同肌膚問題提供安全、溫和的修復方案。以下為本會提供的療程項目，
            按部位與問題分類，方便你了解適合自己的護理方向。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="https://wa.me/85269438757"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md bg-brand-600 hover:bg-brand-700 text-white text-sm tracking-wider whitespace-nowrap cursor-pointer transition"
            >
              <i className="ri-whatsapp-line"></i> WhatsApp 專人即時諮詢
            </a>
          </div>
        </div>
      </section>

      {/* Category filter */}
      <div className="sticky top-16 md:top-20 z-30 bg-white/95 backdrop-blur border-b border-brand-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex gap-2 overflow-x-auto py-4">
            <button
              onClick={() => setActive("all")}
              className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition border ${
                active === "all" ? "bg-brand-600 border-brand-600 text-white" : "border-brand-200 text-brand-700 hover:bg-brand-50"
              }`}
            >
              全部療程
            </button>
            {treatmentCategories.map((c) => (
              <button
                key={c.id}
                onClick={() => setActive(c.id)}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition border ${
                  active === c.id ? "bg-brand-600 border-brand-600 text-white" : "border-brand-200 text-brand-700 hover:bg-brand-50"
                }`}
              >
                <i className={c.icon}></i> {c.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Sections */}
      <section className="py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8 space-y-16">
          {visible.map((c) => (
            <div key={c.id} id={c.id} className="scroll-mt-40">
              <div className="flex items-start gap-4 mb-8">
                <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-brand-600 text-white">
                  <i className={`${c.icon} text-xl`}></i>
                </div>
                <div>
                  <h2 className="font-serif text-2xl md:text-3xl text-brand-800">{c.label}</h2>
                  <p className="mt-2 text-sm text-brand-700/70 max-w-2xl">{c.intro}</p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {c.items.map((item) => (
                  <TreatmentCard key={item.name} item={item} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-20 bg-brand-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h2 className="font-serif text-2xl md:text-4xl text-white">受頑固皮膚問題或產後紋路困擾？</h2>
          <p className="mt-4 text-white/70 max-w-xl mx-auto text-sm md:text-base">
            告別反覆刺激與無效護理。由 ISHB 專科團隊結合中醫根源調理與 AI 超離子專利技術，為你進行專業皮膚評估，定制安全、無創的深層修復方案。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://wa.me/85269438757"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-md bg-white text-brand-800 hover:bg-brand-50 text-sm tracking-wider whitespace-nowrap cursor-pointer transition"
            >
              <i className="ri-whatsapp-line"></i> WhatsApp 專人即時諮詢
            </a>
          </div>
        </div>
      </section>

      <TreatmentInquiryForm />
      <NewsletterSignup />

      <Footer />
    </div>
  );
}